import { useEffect, useState } from "react";
import { database } from "../firebase/firebase";
import { ref, onValue } from "firebase/database";
import "../styles/main.css";

export default function StockReport(){

const [items,setItems] = useState([]);

useEffect(()=>{

const itemRef = ref(database,"items");

onValue(itemRef,(snapshot)=>{

const data = snapshot.val();

if(!data){
setItems([]);
return;
}

const list = Object.entries(data).map(([id,item])=>({
id,
...item
}));

setItems(list);

});

},[]);

return(

<div className="mobile-app">

<div className="page-header">
<h2>Stock Report</h2>
</div>

<div className="section">

{items.map((item)=>(
<div key={item.id} className="card">

<p><b>Item:</b> {item.name}</p>

<p><b>Price:</b> ₹{item.price}</p>

<p><b>GST:</b> {item.gst}%</p>

<p><b>Stock:</b> {item.stock}</p>

</div>
))}

</div>

</div>

)

}